/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PlayPauseFormativeAction model module.
 * @module model/PlayPauseFormativeAction
 * @version 1.0
 */
class PlayPauseFormativeAction {
    /**
     * Constructs a new <code>PlayPauseFormativeAction</code>.
     * @alias module:model/PlayPauseFormativeAction
     */
    constructor() { 
        
        PlayPauseFormativeAction.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PlayPauseFormativeAction</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PlayPauseFormativeAction} obj Optional instance to populate.
     * @return {module:model/PlayPauseFormativeAction} The populated <code>PlayPauseFormativeAction</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PlayPauseFormativeAction();

            if (data.hasOwnProperty('formative_action_id')) {
                obj['formative_action_id'] = ApiClient.convertToType(data['formative_action_id'], 'Number');
            }
            if (data.hasOwnProperty('formative_action_title')) {
                obj['formative_action_title'] = ApiClient.convertToType(data['formative_action_title'], 'String');
            }
            if (data.hasOwnProperty('formative_action_code')) {
                obj['formative_action_code'] = ApiClient.convertToType(data['formative_action_code'], 'String');
            }
            if (data.hasOwnProperty('teaching_hours')) {
                obj['teaching_hours'] = ApiClient.convertToType(data['teaching_hours'], 'Number');
            }
            if (data.hasOwnProperty('last_enroll_id')) {
                obj['last_enroll_id'] = ApiClient.convertToType(data['last_enroll_id'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} formative_action_id
 */
PlayPauseFormativeAction.prototype['formative_action_id'] = undefined;

/**
 * @member {String} formative_action_title
 */
PlayPauseFormativeAction.prototype['formative_action_title'] = undefined;

/**
 * @member {String} formative_action_code
 */
PlayPauseFormativeAction.prototype['formative_action_code'] = undefined;

/**
 * @member {Number} teaching_hours
 */
PlayPauseFormativeAction.prototype['teaching_hours'] = undefined;

/**
 * @member {Number} last_enroll_id
 */
PlayPauseFormativeAction.prototype['last_enroll_id'] = undefined;






export default PlayPauseFormativeAction;

